<script setup lang="ts">
const backgroundUrl = computed(() => {
  const url = '/frontline/FrontlineDashboard_TopBanner_Background.svg';
  if (window.injectedUrl) {
    return window.injectedUrl + url;
  } else {
    return url;
  }
});
</script>

<template>
  <div
    class="h-80px flex flex-col justify-around bg-no-repeat bg-cover"
    :style="{ 'background-image': `url(${backgroundUrl})` }"
  ></div>
</template>
